export interface Tq3DraftM {
  summerSWDraft: string;
  summerDWT: string;
  summerTPC: string;
  winterSWDraft: string;
  winterDWT: string;
  winterTPC: string;
}

export interface TableRow {
  id: number;
  draft: string;
  dwt: string;
  tpc: string;
}

export const getDefaultDraftTableTq3 = (): TableRow[] => {
  return [
    { id: 1, draft: "", dwt: "", tpc: "" },
    { id: 2, draft: "", dwt: "", tpc: "" },
    { id: 3, draft: "", dwt: "", tpc: "" },
    { id: 4, draft: "", dwt: "", tpc: "" },
    { id: 5, draft: "", dwt: "", tpc: "" },
  ];
};

export const tq3DraftFromInit = {
  summerSWDraft: "",
  summerDWT: "",
  summerTPC: "",
  winterSWDraft: "",
  winterDWT: "",
  winterTPC: "",
};

export function mapSqlToTq3DraftForm(_draft: any): any {
  return _draft.map((item: any) => ({
    id: parseInt(item.ID),
    draft: item.DRAFT,
    dwt: item.DWT,
    tpc: item.TPC,
  }));
}

export function mapSqlToTq3DraftSummerWinterForm(_draftSummwerWinter: any): any {
  return {
    summerSWDraft: _draftSummwerWinter?.SUMMER_SW_DRAFT || "",
    summerDWT: _draftSummwerWinter?.SUMMER_DWT || "",
    summerTPC: _draftSummwerWinter?.SUMMER_TPC || "",
    winterSWDraft: _draftSummwerWinter?.WINTER_SW_DRAFT || "",
    winterDWT: _draftSummwerWinter?.WINTER_DWT || "",
    winterTPC: _draftSummwerWinter?.WINTER_TPC || "",
  };
}
